interface Props {
    debug?: boolean;
}

import AdobeAnalyticsListener from './adobe-analytics/AdobeAnalyticsListener';
import AppInsightsListener from './app-insights/AppInsightListener';

// This component will contain any children that will listen for analytics or logging events
function TelemetryListener({ debug = false }: Props) {
    const appInsightsEnabled = !!process.env.APP_INSIGHTS_CONNECTION_STRING;
    const adobeEnabled = !!process.env.ADOBE_LAUNCH_SCRIPTURL;
    return (
        <>
            {appInsightsEnabled && (
                <AppInsightsListener
                    config={{
                        connectionString: process.env.APP_INSIGHTS_CONNECTION_STRING,
                    }}
                    debug={debug}
                />
            )}
            {adobeEnabled && <AdobeAnalyticsListener />}
        </>
    );
}

export default TelemetryListener;
